<template>
    <div class="pagination-container">
        <button @click="prevPage" :disabled="currentPage === 1" class="pagination-button">{{ $t('anterior') }}</button>

        <span>{{ $t('pagina') }} {{ currentPage }} de {{ totalPages }}</span>

        <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-button">{{ $t('siguiente')
            }}</button>

        <select v-model="selectedPageSize" @change="updatePageSize" class="pagination-select">
            <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>

        <span> de {{ total }} items</span>
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            default: 10
        },
        modelValue: {
            type: Number,
            default: 1
        }
    },
    emits: ['update:modelValue', 'update:perPage'],
    data() {
        return {
            currentPage: this.modelValue,
            selectedPageSize: this.perPage,
            pageSizes: [10, 20, 50, 100]
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.selectedPageSize);
        },
        filteredPageSizes() {
            return this.pageSizes.filter(size => size < this.total);
        }
    },
    watch: {
        modelValue(newValue) {
            this.currentPage = newValue;
        },
        currentPage(newPage) {
            this.$emit('update:modelValue', newPage);
        },
        selectedPageSize(newPageSize) {
            this.$emit('update:perPage', newPageSize);
        }
    },
    methods: {
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        updatePageSize() {
            this.currentPage = 1;
            this.$emit('update:perPage', this.selectedPageSize);
            this.$emit('update:modelValue', this.currentPage);
        }
    }
};
</script>

<style scoped>
.pagination-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pagination-button {
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
    cursor: pointer;
    transition: background-color 0.3s;
}

.pagination-button:hover {
    background-color: #e0e0e0;
}

.pagination-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-select {
    padding: 6px;
    border-radius: 10px;
    border: 1px solid #ccc;
}
</style>
